// trackReducer.js
import {
  FETCH_IN_PROGRESS_REQUESTS_REQUEST,
  FETCH_IN_PROGRESS_REQUESTS_SUCCESS,
  FETCH_IN_PROGRESS_REQUESTS_FAILURE,
  FETCH_COMPLETED_REQUESTS_REQUEST,
  FETCH_COMPLETED_REQUESTS_SUCCESS,
  FETCH_COMPLETED_REQUESTS_FAILURE,
  FETCH_QUERIED_REQUESTS_REQUEST,
  FETCH_QUERIED_REQUESTS_SUCCESS,
  FETCH_QUERIED_REQUESTS_FAILURE,
  FETCH_REJECTED_REQUESTS_REQUEST,
  FETCH_REJECTED_REQUESTS_SUCCESS,
  FETCH_REJECTED_REQUESTS_FAILURE,
} from '../actions/trackActionTypes';

const initialState = {
  inProgress: [], // Array to store in-progress requests
  completed: [], // Array to store completed requests
  queried: [], // Array to store queried requests
  rejected: [], // Array to store rejected requests
  isLoading: false, // Loading state
  fetchInProgressError: null, // Error state for in-progress requests
  fetchCompletedError: null, // Error state for completed requests
  fetchQueriedError: null, // Error state for queried requests
  fetchRejectedError: null, // Error state for rejected requests
};

const trackReducer = (state = initialState, action) => {
  switch (action.type) {
    // In-Progress Requests
    case FETCH_IN_PROGRESS_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchInProgressError: null,
      };

    case FETCH_IN_PROGRESS_REQUESTS_SUCCESS:
      return {
        ...state,
        inProgress: action.payload,
        isLoading: false,
        fetchInProgressError: null,
      };

    case FETCH_IN_PROGRESS_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchInProgressError: action.payload,
      };

    // Completed Requests
    case FETCH_COMPLETED_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchCompletedError: null,
      };

    case FETCH_COMPLETED_REQUESTS_SUCCESS:
      return {
        ...state,
        completed: action.payload,
        isLoading: false,
        fetchCompletedError: null,
      };

    case FETCH_COMPLETED_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchCompletedError: action.payload,
      };

    // Queried Requests
    case FETCH_QUERIED_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchQueriedError: null,
      };

    case FETCH_QUERIED_REQUESTS_SUCCESS:
      return {
        ...state,
        queried: action.payload,
        isLoading: false,
        fetchQueriedError: null,
      };

    case FETCH_QUERIED_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchQueriedError: action.payload,
      };

    // Rejected Requests
    case FETCH_REJECTED_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchRejectedError: null,
      };

    case FETCH_REJECTED_REQUESTS_SUCCESS:
      return {
        ...state,
        rejected: action.payload,
        isLoading: false,
        fetchRejectedError: null,
      };

    case FETCH_REJECTED_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchRejectedError: action.payload,
      };

    default:
      return state;
  }
};

export default trackReducer;
